module.exports = __webpack_public_path__ + "static/media/agency_banner-lg.937b4422.jpg";